import { render } from "./BackgroundAssets.vue?vue&type=template&id=8f2f22c6&scoped=true"
import script from "./BackgroundAssets.vue?vue&type=script&lang=js"
export * from "./BackgroundAssets.vue?vue&type=script&lang=js"

import "./BackgroundAssets.vue?vue&type=style&index=0&id=8f2f22c6&scoped=true&lang=scss"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/ritual/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2f22c6"]])

export default __exports__